import Container from '@/components/Container';

import ChoseThemeFilter from './ChoseThemeFilter';
import Highlight from './Highlight';
import LatestByTheme from './LatestByTheme';
import KnowledgeHubSkeleton from './KnowledgeHub.skeleton';
import Tabs from '@/components/ui/tabs';
import ResourcePage from '../resource';
import MainPage from '../main';
import SearchTabKnowledgeHub from './SearchTab';
import useKnowledgeHub from './hooks/useKnowledgeHub';
import { useLocation } from 'react-router-dom';
import useIsTablet from '@/hooks/useIsTablet';

export default function KnowledgeHub() {
  const { tabs, highlightsForTopic, topic, loading, slug, filterActive, setTabs, loadingThemeContent } =
    useKnowledgeHub();
  const location = useLocation();
  const { isTablet } = useIsTablet();
  if (loading) {
    return <KnowledgeHubSkeleton />;
  }

  const isSearch = location.pathname.includes('search');

  return (
    <Container className="min-h-40" addMargin={!isTablet}>
      <div className="col-span-12">
        <Tabs tabs={tabs} setTabs={setTabs}>
          {!isSearch ? (
            <div>
              {!slug && <ChoseThemeFilter topic={topic!} />}
              {slug && <ResourcePage />}
              {!filterActive && !slug && !topic && <Highlight highlightsForTopic={highlightsForTopic} />}
              {!slug && topic && !loadingThemeContent && <LatestByTheme topic={topic!} />}
              {!slug && !topic && <MainPage />}
            </div>
          ) : (
            <SearchTabKnowledgeHub />
          )}
        </Tabs>
      </div>
    </Container>
  );
}
